import { ProfileConstants } from './types';
import { PasswordConstants } from './types';

export const profileInitialState = {
  id: undefined,
  firstName: '',
  lastName: undefined,
  email: undefined,
  phone: undefined,
  is_user_manager: undefined,
  is_alert_manager: undefined,
  is_staff: undefined,
  message: undefined,
  error: undefined,
};

export function profileReducer(state = profileInitialState, action) {
  switch (action.type) {
    case ProfileConstants.SetProfile:
      return {
        ...state,
        id: action.payload.id,
        firstName: action.payload.first_name,
        lastName: action.payload.last_name,
        email: action.payload.email,
        phone: action.payload.phone_number,
        is_user_manager: action.payload.is_user_manager,
        is_alert_manager: action.payload.is_alert_manager,
        is_staff: action.payload.is_staff,
      };
    case ProfileConstants.ProfileUpdated:
      return {
        ...state,
        id: action.payload.id,
        firstName: action.payload.first_name,
        lastName: action.payload.last_name,
        email: action.payload.email,
        phone: action.payload.phone_number,
        message: 'Successfully updated profile.',
      };
    case ProfileConstants.ProfileFailure:
      return {
        ...state,
        message: undefined,
        error: action.payload,
      };
    case ProfileConstants.ClearStatus:
      return {
        ...state,
        message: undefined,
        error: undefined,
      };
    default:
      return state;
  }
}

export const passwordInitialState = {
  message: undefined,
  error: undefined,
};

export function passwordReducer(state = passwordInitialState, action) {
  switch (action.type) {
    case PasswordConstants.PasswordChanged:
      return {
        ...state,
        message: action.payload,
        error: undefined,
      };
    case PasswordConstants.PasswordFailure:
      return {
        ...state,
        message: undefined,
        error: action.payload,
      };
    case PasswordConstants.ClearStatus:
      return {
        ...state,
        message: undefined,
        error: undefined,
      };
    default:
      return state;
  }
}
